"use client";

import { ThemeProvider } from "@/components/ThemeProvider";

export function Theme({ children }: { children: React.ReactNode }) {
    return (
        <ThemeProvider attribute="class" value={{ light: "light-mode", dark: "dark-mode" }} enableSystem>
            {children}
        </ThemeProvider>
    );
}
